module.exports = __webpack_public_path__ + "fonts/TTFirs-Light.d38957ec.eot";